"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompletedHouses = void 0;
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var React = _interopRequireWildcard(require("react"));
var _Content = require("../../../Layout/Content");
var styles = _interopRequireWildcard(require("./CompletedHouses.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CompletedHouses = props => {
  const [open, setOpenState] = React.useState(false);
  const setClose = React.useCallback(() => setOpenState(false), []);
  const setOpen = React.useCallback(() => setOpenState(true), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.IconButton, {
    icon: /*#__PURE__*/React.createElement(_icons.IconFunctionalInformationCircle16, {
      color: "gray40_100"
    }),
    onClick: setOpen
  }), /*#__PURE__*/React.createElement(_uiKit.ModalWindow, {
    title: "\u0414\u043E\u043C\u0430, \u0432\u0432\u0435\u0434\u0451\u043D\u043D\u044B\u0435 \u0432 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u044E",
    open: open,
    onClose: setClose,
    size: "M",
    content: /*#__PURE__*/React.createElement(_Content.Content, null, props.completedHouses.map(house => /*#__PURE__*/React.createElement("div", {
      className: styles['item'],
      key: house.name
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['row']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
      color: "black_40"
    }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043C\u0430")), /*#__PURE__*/React.createElement("div", {
      className: styles['value']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, house.name))), /*#__PURE__*/React.createElement("div", {
      className: styles['row']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
      color: "black_40"
    }, "\u0417\u0430\u0434\u0435\u0440\u0436\u043A\u0430")), /*#__PURE__*/React.createElement("div", {
      className: styles['value']
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
      color: house.hasDelay ? 'rijckaya_100' : 'text-primary-default'
    }, house.delay))))))
  }));
};
exports.CompletedHouses = CompletedHouses;